import { LuAudioLines, LuVideo, LuImage } from "react-icons/lu"

import SafeImage from "./ui/SafeImage"

export default function AssetThumbnail({asset, className, fit='object-cover', showMediaType=true}){

    const thumb = (asset.mediaType === 'image' || asset.mediaType === 'video') && asset.thumbnail_url
        ? asset.thumbnail_url
        : null

    const videoFallback = !thumb && asset.mediaType === 'video' && asset.url

    const getIcon = () =>{
        if(asset.mediaType === 'audio') return <LuAudioLines className='w-1/2 h-1/2 text-secondary-foreground/50' />
        if(asset.mediaType === 'video') return <LuVideo className='w-1/2 h-1/2 text-secondary-foreground/50' />
        if(asset.mediaType === 'image') return <LuImage className='w-1/2 h-1/2 text-secondary-foreground/50' />
    }

    return (
        <div className={`flex justify-center items-center relative overflow-hidden w-full h-full ${className} ${thumb || videoFallback ? '' : 'bg-secondary'}`}>
            {thumb && <SafeImage src={thumb} alt={asset.name} fill className={fit} />}
            {videoFallback && <video src={asset.url} preload="metadata" muted playsInline className={`w-full h-full ${fit}`} />}
            {!thumb && !videoFallback && getIcon()}
        </div>
    )
}